export enum TagType {
  Feature = 'FEATURE',
  Genre = 'GENRE'
}
